<template>
    <div>
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{nameValue}}</template>
            </div>
        </mt-cell>
        <mt-tree-selector :parentSelectable="parentNodeSelectable" :label="model.caption" v-if="!param.readonly && model.xtype === 'tree'" :options="unblindOptions" v-model="currentValue" :placeholder="param.placeholder" :defName="nameValue" :titlewidth="titlewidth" :value-align="textalign" :displayType="unblind" :required="model.required" @selector-click="loadSubOptions"></mt-tree-selector>
        <mt-tree-selector multiple :label="model.caption" v-if="!param.readonly && model.xtype === 'multi-tree'" :options="unblindOptions" v-model="currentValue" :placeholder="param.placeholder" :defName="nameValue" :titlewidth="titlewidth" :value-align="textalign" :displayType="unblind" :required="model.required" @selector-click="loadSubOptions"></mt-tree-selector>
    </div>
</template>
<script>
import { parseParam, validate, queryDic } from '../formUtils.js';
export default {
    name: 'emTree',
    data() {
        return {
            currentValue: this.value?this.value:'',
            nameValue: this.displayValue,
            popupVisible: false,
            unblindOptions:this.options,
            unblind:'',
            parentNodeSelectable:true
        }
    },
    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '' },
        displayValue: { default: '' },
        options: {
            type: Array,
            default: function() {
                return []
            }
        },
        titlewidth: {
            type: String,
            default: function() {
                return '';
            }
        },
        textalign: {
            type: String,
            default: function() {
                return ''; //flex-start
            }
        }
    },
    computed: {
        param() {
            return this.model.initParam;
        },
        columns() {
            
        }
    },
    mounted() {
        var that = this;
        var JSONParam = that.model && that.model.initParam;
        if (JSONParam && JSONParam.hasOwnProperty('parentNodeSelectable')) {
            that.parentNodeSelectable = JSONParam.parentNodeSelectable;
        }
        that.unblind = that.param.unblind || (window._EMAPMFORM_unblind?window._EMAPMFORM_unblind.unblind:'') || "/";
        window.addEventListener("popstate", function (e) {
            //console.log('form',e);
            $('body').removeClass('vf-h');
            $('#app').removeClass('vf-h');
        }, false);
    },
    watch:{
        value(val){
            this.currentValue =val?val:'';
            $('body').removeClass('vf-h');
            $('#app').removeClass('vf-h');
        },
        displayValue(val){
            this.nameValue = val;
        },
        currentValue(val){
            this.$emit('input', val);
        },
        options(val){
            var that = this;
            //debugger
            if(val.length>0){
                if(that.unblind){
                    that.unblindOptions = [];
                    val.forEach(function(item){
                        var lastIndex = item.name.lastIndexOf(that.unblind);
                        item.name = item.name.slice(lastIndex + 1);
                        that.unblindOptions.push(item);
                    })
                }else {
                    that.unblindOptions = val;
                } 
            } 
        },
        unblindOptions(val){
            console.log('unblindOptions',val)
        }
    },
    methods: {
        loadSubOptions(id,event){
            $('body').addClass('vf-h');
            $('#app').addClass('vf-h');
            var that = this;
            var pId = '';
            if(id != 'custom'){
                pId = id;
            }
            queryDic(this.model.url, {pId:pId}).then(rows => {
                if(rows.length>0){
                    if(that.haveNoRepeatOptions(rows[0])){
                        rows.map(function(item){
                            var lastIndex = item.name.lastIndexOf(that.unblind);
                            item.name = item.name.slice(lastIndex + 1);
                            that.unblindOptions.push(item);
                        });
                    }
                }
            });
        },
        haveNoRepeatOptions(item){
            var result = true;
            this.unblindOptions.forEach(element => {
                if(element.id === item.id){
                    result = false;
                }
            });
            return result;
        }
    }
};
</script>


// WEBPACK FOOTER //
// emTree.vue?046ca598